import React, { useEffect, useState } from 'react';
import Page, { usePage } from '../../components/Page';
import { useAuth } from '../../units/auth/AuthProvider';
import { Button, Grid, Typography } from '@mui/material';
import { useSideBar } from '../../components/SideBar';
import { useStyles } from '../../hooks/useStyles';
import moment from 'moment';
import { api } from '../../api';
import { TimelineArray } from '../../data/Timeline';
import { useScreenSize } from '../../hooks/useScreenSize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarClock, faCars, faSignIn, faSignOut, faSquareUser } from '@fortawesome/pro-regular-svg-icons';
import { NavigateOptions, To, useNavigate } from 'react-router-dom';
import { grey } from '@mui/material/colors';

export const usePriceListPage = () => {
    const page = usePage();
    const classes = useStyles();
    const auth = useAuth();
    const screenSize = useScreenSize();
    const navigate = useNavigate();
    const navigateTo = (to: To, options?: NavigateOptions | undefined) => () => navigate(to, options);
    const sideBar = useSideBar();
    return { page, classes, auth, navigate, navigateTo, screenSize, sideBar };
};

interface PriceListPageProps {}

export const PriceListPage = (homePageProps: PriceListPageProps): React.ReactElement => {
    const props = usePriceListPage();
    return (
        <Page {...props.page} title='價目表'>
            <Grid container flexDirection={'row'} height={'100%'}>
                <Grid
                    container
                    item
                    flex={1}
                    flexDirection={'column'}
                    padding={4}
                    sx={{
                        backgroundColor: grey[100],
                        backgroundImage: `url(${require('../../img/price_list.jpg')})`,
                        backgroundSize: 'contain',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        overflow: 'hidden',
                    }}
                ></Grid>
            </Grid>
        </Page>
    );
};
